import { useStore as baseUseStore } from 'vuex'
import { key } from '@/store/index.ts'

export function useStore() {
  return {
    store: baseUseStore(key),
  }
}
